import { Department, Permission } from '../types';
import { useFetchData } from "../../../hooks/useFetch";
import { API_PRIVILEGE_ROUTER, ApiConfig, API_DEPARTMENT_ROUTER } from "../../../services/api-config";

export interface DepartmentListResponse {
  list: Department[];
  total_record?: number;
  limit?: number;
}

export interface PrivilegeListResponse {
  list: Permission[];
  total_record?: number;
  limit?: number;
}

export interface DepartmentPermissionResponse {
  group: number;
  privileges: number[];
}

export interface DepartmentListFilters {
  status?: number;           // 1 active, 0 inactive, -1 all
  company_id?: number;
  parent_department_id?: number;
  keyword?: string;
}

export interface PrivilegeListFilters {
  status?: number;           // 1 active, 0 inactive, -1 all
  keyword?: string;
}

export interface UpdatePermissionPayload {
  privilege_ids: number[];
}

export interface UpdatePermissionDepartmentResponse{
  massage: string;
}

export const permissionDepartmentService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<DepartmentListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: DepartmentListFilters = { status: -1 }) =>
        request({
          endPoint: API_DEPARTMENT_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  listPermission: () => {
    const { request, baseResponse, loading } = useFetchData.Get<PrivilegeListResponse>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (params: PrivilegeListFilters = { status: 1 }) =>
        request({
          endPoint: API_PRIVILEGE_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  getPermissionsForDepartment: () => {
    const { request, baseResponse, loading } = useFetchData.Get<DepartmentPermissionResponse[]>({
      projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
    });
    return {
      fetch: (id: number) =>
        request({
          endPoint: API_DEPARTMENT_ROUTER.API_PRIVILEGE(id),
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  updatePermissionsForDepartment: () => {
      const { request, baseResponse, loading } = useFetchData.Post<UpdatePermissionDepartmentResponse>({
        projectId: ApiConfig.PROJECT_ID.USER_SERVICE,
      });
      return{
        fetch: (id: number, payload: UpdatePermissionPayload) =>
          request({
            endPoint: API_DEPARTMENT_ROUTER.API_UPDATE_PRIVILEGE(id),
            data: payload,
          }),
        response: baseResponse,
        loading: loading
      }
    }
}